module.exports = __webpack_public_path__ + "static/vaporator-d503875b2666ddd0fed2e036c28ce37d.png";